import React from 'react';
//import ReactDOM from 'react-dom/client';
//import { hydrate, render } from "react-dom";
import ReactDOM from 'react-dom';

import './style.css';

import Game from './components/Game';
import Result from './components/Result';
import Main from './Main';
import OurMiniGames from './components/OurMiniGames';
import HowToPlay from './components/HowToPlay';
import Minigame from './components/games/Minigame';
import PlayGame from './components/games/PlayGame';
import Header from './components/Header';
import Footer from './components/footer/Footer';
import Tilesets from './components/Tilesets';
import ZestawySpodLady from './components/ZestawySpodLady';
import general from './static/json/general.json';

import Pairs from './components/games/Pairs';


import CookiePolicy from './components/footer/CookiePolicy';
import PrivacyPolicy from './components/footer/PrivacyPolicy';
import Terms from './components/footer/Terms';
import Contact from './components/footer/Contact';
import OurGames from './components/OurGames';
import WordSearch from './components/WordSearch';
import Badges from './components/results/Badges';
import { countStars } from './components/results/stars.js';


import './i18n';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import ReactGA from 'react-ga4';
ReactGA.initialize('G-ZGRQLF886B');


function Root() {

	const languages = ["en", "de", "it", "fr"];
    const games = ["tiles", "pairs", "infinite", "same", "timed", "lines", "unpaired"];
    const tilesets = general["waiting"].map(tset => tset.name);

    var generalImproved = {};
    generalImproved["tiles"] = tilesets;
    generalImproved["pairs"] = tilesets;
    generalImproved["timed"] = tilesets;
    generalImproved["infinite"] = tilesets;
    generalImproved["unpaired"] = tilesets;
    generalImproved["lines"] = general["lines"].map(tset => tset.name);;
    generalImproved["same"] = general["same"];

	var url = window.location.href;

	if(!url.includes("www") && url.includes("unlimited")) {
		var newUrl = url;
		newUrl = newUrl.replace("unlimited", "www.unlimited");
		if(url != newUrl) {

			window.location.href = newUrl;
		}
	}

	var hasStars = localStorage.getItem("tiles-portugal-stars");
	console.log(hasStars != null);
	if(!hasStars) {
		countStars();
	}


	return (
		<>
			<Header/>
			<Router>
				<div className="App">
	            <Routes>
	                    <Route path="/" element={<Main lang="en" />} />
	                    <Route path="/de" element={<Main lang="de" />} />
	                    <Route path="/it" element={<Main lang="it" />} />
	                    <Route path="/fr" element={<Main lang="fr" />} />

	                    <Route path="/howtoplay" element={<HowToPlay />} />
	                    <Route path="/games" element={<OurMiniGames />} />
	                    <Route path="/zestawy_spod_lady" element={<ZestawySpodLady />} />

	                    <Route path="/cookies" element={<CookiePolicy />} />
	                    <Route path="/privacy" element={<PrivacyPolicy />} />
	                    <Route path="/terms" element={<Terms />} />
	                    <Route path="/contact" element={<Contact />} />
	                    <Route path="/ourgames" element={<OurGames />} />
	                    <Route path="/wordsearch" element={<WordSearch />} />
	                    <Route path="/badges" element={<Badges />} />

						{/*TILES
				        {languages.map(lang => (
				            <Route key={lang} path={`/${lang}/tilesets`}
					                element={<Tilesets game="tiles" lang={lang} />}
					        />
				            )
				        )}
				        {languages.map(lang =>
				            tilesets.map(tileset => (
				                <>
					                <Route
					                    key={lang}
					                    path={`/${lang}/${tileset}`}
					                    element={<Game game="tiles" lang={lang} tileset={tileset} />}
					                />
				                    <Route
					                    key={lang}
					                    path={`/${lang}/${tileset}/result`}
					                    element={<Result game="tiles" lang={lang} tileset={tileset} />}
					                />
				                    <Route
					                    key={lang}
					                    path={`/${lang}/${tileset}/play`}
					                    element={<PlayGame lang={lang} game="tiles" tileset={tileset} />}
					                />

				                </>
				            ))
				        )}
				        */}


				        {languages.map(lang =>
				            games.map(game => (
				                <>
						            <Route key={lang} path={`/${lang}/${game}`}
							                element={<Minigame lang={lang} game={game} />}
							        />
						            <Route key={lang} path={`/${lang}/${game}/tilesets`}
							                element={<Tilesets lang={lang} game={game} />}
							        />

						            {generalImproved[game].map(tileset => (
						                <>
							                <Route
							                    key={game + "-" + lang}
							                    path={`/${lang}/${game}/${tileset}`}
							                    element={<Game game={game} lang={lang} tileset={tileset} />}
							                />
							                <Route
							                    key={game + "-" + lang}
							                    path={`/${lang}/${game}/${tileset}/result`}
							                    element={<Result game={game} lang={lang} tileset={tileset} />}
							                />
							                <Route
							                    key={game + "-" + lang}
							                    path={`/${lang}/${game}/${tileset}/play`}
							                    element={<PlayGame lang={lang} game={game} tileset={tileset} />}
							                />
						                </>
						            ))}

						        </>
				            ))
				        )}

	                    <Route path="/*" element={<Main lang="en" />} />
	            </Routes>


            </div>
			</Router>
			<Footer/>

		</>
		//</React.StrictMode>

	);
};


ReactDOM.render(<Root />, document.getElementById('root'));
const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(<Root />, rootElement);
} else {
  ReactDOM.render(<Root />, rootElement);
}
